import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import withUser from '../HOC/HOCwithUser.jsx';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';
import {
    List,
    ListItem,
    ListItemAvatar,
    Button,
    ListItemSecondaryAction,
    ListItemText,
    Paper,
    TextField,
    Dialog,
    Fade,
    MenuItem,
    CircularProgress
} from '@material-ui/core';
import ProgressiveImage from 'react-progressive-image';
import ContentLoader from 'react-content-loader';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import { FacebookShareButton, FacebookIcon, TwitterIcon, EmailIcon, TwitterShareButton, EmailShareButton } from 'react-share';
import { Share } from '@material-ui/icons';
import { getCookies } from '../../utils/getToken.js';
import { SERVER_URL } from '../../utils/config/constants.js';
import DateTimePanel from '../Booking/DateTimePanel.jsx';
import Dropzone from 'react-dropzone';
import { NotificationManager } from 'react-notifications';
import StarRatings from 'react-star-ratings';
import Axios from 'axios';

const styles = theme => ({
    root: {
        width: '100%'
    },
    inline: {
        display: 'inline'
    },
    margin: {
        margin: theme.spacing.unit
    },
    extendedIcon: {
        marginRight: theme.spacing.unit
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        marginBottom: '10px'
    }
});


class HolidayList extends React.Component {
    constructor() {
        super();
        this.handleDrop = this.handleDrop.bind(this);
    }
    state = {
        mainData: [],
        showAddHolidayDialog: false,
        category: "",
        notes: "",
        isImage: false,
        openDateTime: false,
        dateTimeToValue: "",
        dateFromTimeValue: "",
        imageFiles: [],
        loader: true,
        reason: ''


    }
    componentDidMount() {
        this.getMainLog();
    }
    getMainLog = () => {
        var authToken = getCookies();
        Axios({
            method: 'get',
            url: `${SERVER_URL}/provider/list-holidays`,
            headers: {
                'x-auth-Token': authToken
            }
        }).then((Response) => {
            if (Response.data.status == 'OK') {
                this.setState({
                    mainData: Response.data.data,
                    loader: false
                })
            }
            else {
                NotificationManager.error("Oops!", Response.data.message)
                this.setState({
                    mainData: [],
                    loader: false
                })
            }
        })
    }

    onFromChangeDate = event => {
        console.log("date event::::::::", event)
        const dateTimeValue = moment(event).format('MM-DD-YYYY');
        this.setState({ dateFromTimeValue: dateTimeValue, openDateTime: false });
    };
    onToChangeDate = event => {
        console.log("date event::::::::", event)
        const dateTimeValue = moment(event).format('MM-DD-YYYY');
        this.setState({ dateTimeToValue: dateTimeValue, openDateTime: false });
    };
    closeDialog = () => {
        this.setState({
            showAddHolidayDialog: false,
            dateTimeToValue: "",
            dateFromTimeValue: "",
        })
    }

    handleDrop(files) {
        this.setState({
            isImage: true,
            imageFiles: this.state.imageFiles.concat(files.map(file =>
                Object.assign(file, {
                    preview: URL.createObjectURL(file),
                })))
        })
    }

    applyHoliday = () => {
        var authToken = getCookies();
        Axios({
            method: 'post', //you can set what request you want to be
            url: `${SERVER_URL}/user/apply-holiday`,
            // params,
            headers: {
                'x-auth-Token': authToken
            },
            data: {
                reason: this.state.reason,
                start: this.state.dateFromTimeValue + ' ' + '00:00:00',
                end: this.state.dateTimeToValue + ' ' + '00:00:00'
            }

        }).then(response => {
            console.log("Response:::::", response)
            if (response.data.status == 'OK') {
                console.log('success')
                NotificationManager.success("Success", response.data.message)
                this.setState({
                    showAddHolidayDialog: false,
                    dateTimeToValue: "",
                    dateFromTimeValue: "",
                    loader: false
                })
                this.getMainLog();
            }
            else {
                NotificationManager.error("Oops!", response.data.message)
                this.setState({
                    showAddHolidayDialog: false,
                    dateTimeToValue: "",
                    dateFromTimeValue: "",
                    loader: false
                })
            }
        })
    }

    render() {

        var fromMax = moment().add(0, 'day')

        console.log("datefrom from Max::", fromMax)

        var valid = function (current) {

            console.log("Current from Max::", current)

            return (fromMax <= current);
        };

        /*  if (this.state.dateFromTimeValue) {
             console.log("datefrom::",this.state.dateFromTimeValue)
             var toMax = moment(this.state.dateFromTimeValue).format("YYYY-MM-DD")
 
             var validTo = function (current) {
                 return (toMax);
             };
         }
  */


        /* var toMax = moment().add(0, 'day')

        var valid = function (current) {
            return (max >= current);
        }; */

        if (this.state.loader) {
            return (
                <div style={{ minHeight: '800px' }}>
                    <div className={'loader-view loader-center'}>
                        <CircularProgress color="primary" />
                    </div>
                </div>
            )
        }

        return (
            <div className="md-12" style={{ width: "100%" }}>
                <div className="mt-1 md-12 mr-1" style={{ height: 40, justifyContent: "flex-end", display: "flex" }}>
                    <Button variant="contained" color="primary" style={{ width: 120 }} onClick={() => {
                        this.setState({
                            showAddHolidayDialog: true
                        })
                    }}>Add</Button>
                </div>
                <div className="md-12">
                    {this.state.mainData.length > 0 && this.state.mainData.map((item) => {
                        return (
                            <div className="m-3 p-4" style={{ boxShadow: "2px 2px 4px #dddddd", borderRadius: 5, backgroundColor: "#fffff" }}>
                                <div className="md-12 row">
                                    <div className="d-flex col-md-4" style={{ height: 30, alignItems: "center" }} ><p><b>Days:</b></p></div>
                                    <div className="d-flex col-md-8 " style={{ height: 30, alignItems: "center" }}><p>{item.days}</p></div>
                                </div>
                                <div className="md-12 row">
                                    <div className="d-flex col-md-4" style={{ height: 30, alignItems: "center" }} ><p><b>Start Date:</b></p></div>
                                    <div className="d-flex col-md-8 " style={{ height: 30, alignItems: "center" }}><p>{moment(item.start_date).format('MM-DD-YYYY')}</p></div>
                                </div>
                                <div className="md-12 row">
                                    <div className="d-flex col-md-4" style={{ height: 30, alignItems: "center" }} ><p><b>End Date:</b></p></div>
                                    <div className="d-flex col-md-8 " style={{ height: 30, alignItems: "center" }}><p>{moment(item.end_date).format('MM-DD-YYYY')}</p></div>
                                </div>
                                <div className="md-12 row mt-2">
                                    <div className="d-flex col-md-4" style={{ height: 30, alignItems: "center" }}><p><b>Remark:</b></p></div>
                                    <div className="d-flex col-md-8" style={{ height: 30, alignItems: "center" }}><p>{item.remarks}</p></div>
                                </div>
                                {/* <div className="md-12 mt-2">
                                    {item.customer_images.length > 0 && <p className="mt-1 mb-1"><b>Images:</b></p>}
                                    <div className="md-12 mt-2 row">
                                        {item.customer_images.length > 0 && item.customer_images.map(item => {
                                            return (
                                                <div className="col-md-3 P-2 mt-1 mb-1">
                                                    <img src={item.small} style={{ width: "100%", height: "100%" }} />
                                                </div>
                                            )
                                        })}
                                    </div>
                                </div> */}
                            </div>
                        )
                    })
                    }
                </div>
                {this.state.showAddHolidayDialog &&
                    <Dialog
                        TransitionComponent={Fade}
                        disableBackdropClick={false}
                        fullWidth={true}
                        className="service-suggestion-modal md-4 align-self-center"
                        open={this.state.showAddHolidayDialog}
                        onClose={this.closeDialog}
                        aria-labelledby="form-dialog-title"
                    >
                        <div style={{ backgroundColor: "white" }} className="col p-3 custom-input-text">
                            <form className="col-md-4 mt-1">
                                <DateTimePanel
                                    open={
                                        this.state
                                            .openDateTime
                                    }
                                    isValidDate={valid}
                                    timeFormat={false}
                                    onChange={
                                        this.onFromChangeDate
                                    }
                                    value={
                                        this.state
                                            .dateFromTimeValue
                                    }
                                    fromDate={"From Date"}
                                />
                            </form>
                            {this.state.dateFromTimeValue != "" &&
                                <form className="col-md-4 mt-1">
                                    <DateTimePanel
                                        open={
                                            this.state
                                                .openDateTime
                                        }
                                        isValidDate={valid}
                                        timeFormat={false}
                                        onChange={
                                            this.onToChangeDate
                                        }
                                        value={
                                            this.state
                                                .dateTimeToValue
                                        }
                                        toDate="To Date"
                                    />
                                </form>}

                            <form className="form-new">
                                <TextField
                                    style={{ width: "90%", marginLeft: 15 }}
                                    className="login-form-textfield"
                                    id="reason"
                                    label="Reason"
                                    fullWidth={true}
                                    name="reason"
                                    placeholder={"Enter Reason"}
                                    value={this.state.reason}
                                    onChange={event => {
                                        this.setState({
                                            reason: event.target.value,
                                        });
                                    }}
                                />
                            </form>

                            <div className="md-12 d-flex justify-content-center">


                                <button type="button" class="custom-button"
                                    onClick={() => {
                                        this.applyHoliday()
                                    }}>APPLY HOLIDAY</button>
                            </div>
                        </div>
                    </Dialog>
                }
            </div>
        );
    }
}

const mapStateToProps = ({ settings, auth }) => {
    return {
        settings: settings,
        userData: auth.userData
    };
};
const composedComponent = compose(
    withStyles(styles),
    connect(mapStateToProps, actions)
);

export default composedComponent(HolidayList);



// WEBPACK FOOTER //
// ./src/components/Customer/HolidayList.jsx